import { render, staticRenderFns } from "./paese.vue?vue&type=template&id=23be8465&"
import script from "./paese.vue?vue&type=script&lang=js&"
export * from "./paese.vue?vue&type=script&lang=js&"
import style0 from "./paese.vue?vue&type=style&index=0&id=23be8465&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports